import { Box, Button, FormHelperText, Grid, IconButton, Tooltip, Typography } from '@mui/material'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import DeleteIcon from '@mui/icons-material/Delete'
import React from 'react'

interface Props {
  file: File | null
  onSelect: (file: File | null) => void
  error?: string
  canRemove?: boolean
}

export const SimpleFileInput: React.FC<Props> = ({ file, onSelect, error, canRemove = true }) => {
  const handleSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.files?.[0] || null
    onSelect(selected)
  }

  return (
    <Grid>
      <Button
        variant="contained"
        component="label"
        startIcon={<CloudUploadIcon />}
      >
        Choisir un fichier
        <input type="file" data-testid="simple-file-input" hidden onChange={handleSelect} />
      </Button>

      {file && canRemove && (
        <Tooltip title="Supprimer le fichier">
          <IconButton onClick={() => onSelect(null)} color="primary">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      )}

      {file && (
        <Box mt={2}>
          <Typography variant="body2" color="textSecondary">
            Fichier sélectionné : <strong>{file.name}</strong>
          </Typography>
        </Box>
      )}

      {error && <FormHelperText error>{error}</FormHelperText>}
    </Grid>
  )
}
